import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';
import InfiniteScroll from 'react-infinite-scroller';
import bucketPic from '../media/bucket.png';
import Lightbox from 'react-image-lightbox';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';


export default class ShopProductListing extends Component {
  static propTypes = {
    products: PropTypes.array.isRequired,
    usableProducts: PropTypes.array.isRequired,
    visibleProducts: PropTypes.array.isRequired,
    hasMoreToScroll: PropTypes.bool.isRequired,
    loadMoreScroll: PropTypes.func.isRequired,
    addItemToCart: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      lightboxOpen: false,
      lightboxIndexToOpen: 0
    };
  }

  addOrSubtractOne = (productID, addOrSubtract) => {
    let quantity = document.getElementById("quantity" + productID).value;
    let valToAssign = 1;

    if(quantity != null || quantity != "") {
      quantity = Number(quantity);
      if(quantity <= 1)
      {
        valToAssign = 1;
      }
      else {
        if(addOrSubtract == "subtract")
          valToAssign = quantity -= 1;
        }
        if(addOrSubtract == "add") {
          valToAssign = quantity += 1;
        }
      }

    document.getElementById("quantity" + productID).value = valToAssign;
  }

  render() {
    var Products_ColArray = [];

    this.props.visibleProducts.map((product, index) => {
      Products_ColArray[index] = (<Col xs="6" sm="4" md="4" lg="3" xl="3" key={index}>
         <ListingProductImg onClick={() => this.setState({ lightboxOpen: true, lightboxIndexToOpen: index})} src={product.imgURL}></ListingProductImg>

         <P_Size>{product.sizeDisplay}</P_Size>
         <P_Name>{product.name}</P_Name>
         <P_Price>{product.priceDisplay}</P_Price>

        <InputGroup>
          <InputGroupButtonPlusMinus onClick={() => this.addOrSubtractOne(product.id, "subtract")} addonType="prepend">
             <FontAwesome name="minus" className="fa fa-minus" />
          </InputGroupButtonPlusMinus>
          <Input id={"quantity" + product.id} defaultValue="1" type="number" >
          </Input>
          <InputGroupButtonPlusMinus onClick={() => this.addOrSubtractOne(product.id, "add")} addonType="prepend">
             <FontAwesome name="plus" className="fa fa-plus" />
          </InputGroupButtonPlusMinus>
        </InputGroup>

        <ButtonAdd onClick={() => {this.props.addItemToCart(
          product.id, product.name, product.price, product.url,
          product.sizeOz, product.sizeDisplay, product.imgURL ) }} >
          <p>ADD</p>
        </ButtonAdd>

      </Col>)

    });

    const loader = <LoadingMoreDiv key={0}>Loading more...</LoadingMoreDiv>;

    const ShopProductListing = ( 
      <ShopProductListing_Div>
        <InfiniteScroll className="infiniteScroll"
          pageStart={0} loadMore={() => this.props.loadMoreScroll()}
          hasMore={this.props.hasMoreToScroll} loader={loader}>
          <ProductListing_Row>
              {Products_ColArray}
         </ProductListing_Row>
        </InfiniteScroll>
      </ShopProductListing_Div>
    );

    return (
      <FluidContainer className="p-0" fluid>
          {this.state.lightboxOpen ? 
            <Lightbox mainSrc={this.props.visibleProducts[this.state.lightboxIndexToOpen].imgURL} 
              onCloseRequest={() => this.setState({lightboxOpen: false})}
              imageTitle={ this.props.visibleProducts[this.state.lightboxIndexToOpen].name } />
          : ""
          }
          {ShopProductListing}
      </FluidContainer>
    );
  }
}

const FluidContainer = styled(Container)`  
  //background-color: #822D08;

`;

const ShopProductListing_Div = styled.div`

`;

const ProductListing_Row = styled(Row)`
  //background-color: #822D08;
  padding: 40px 0 0 0!important;

  .col-6 {
    margin: 5px 0 50px 0!important;
  }
  
  text-align: center;

  p {
    font-size: 14px;
    margin-bottom: 0px;
  }
  .input-group {
    margin: 10px 0 5px 0;
    justify-content: center;

    .fa {
      font-size: 20px;
      cursor: pointer;

      ::before {
        vertical-align: middle;
      }
    }

    input {
      z-index: 0;
      border: none;
      background: black;
      height: 40px;
      color: white;
      margin: 0 5px 0 5px;
      border-radius: 6px!important;
      
      min-width: 65px;
      max-width: 65px;
      text-align: center;
    }
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
  }

`;

const ListingProductImg = styled.img`
  width: 100%;
  height: auto;
  cursor: pointer;
  margin-bottom: 5px;
`;

const P_Size = styled.p`
  font-size: 15px!important;
  vertical-align: top;
  margin-bottom: 12px!important;


   ${media.lg` font-size: 16px!important; `}
`;

const P_Name = styled.p`
  font-size: 16px!important;
  vertical-align: top;
  margin-bottom: 5px!important;
  

  ${media.lg` font-size: 17px!important; `}
`;

const P_Price = styled.p`
  font-size: 17px!important;
  vertical-align: top;
  font-family: "Old Standard TT"!important;
  font-weight: bold;

   ${media.lg` font-size: 18px!important; `}
`;

const InputGroupButtonPlusMinus = styled(InputGroupButton)`
  padding-top: 10px;
  
  span {
    width: 20px;
    height: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
`;

const ButtonAdd = styled(Button)`
  cursor: pointer;
  display: inline-block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 130px;
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
    font-size: 20px!important;
  }

  p:after {
    //content: '\00bb';
    content: url(${bucketPic});
    position: absolute;
    opacity: 0;
    top: -20px;
    transform: scale(.5);
    transition: 0.5s;
  }

  :hover p { padding-right: 50px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

const LoadingMoreDiv = styled.div`
    text-align: center!important;
    color: #822D08!important;
    font-weight: bold;
`;



/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopProductListing.js